export const LOAD_WIDGETS_SUCCESS = 'views.LOAD_WIDGETS_SUCCESS';
export const LOAD_WEATHER_SUCCESS = 'views.LOAD_WEATHER_SUCCESS';
export const TOGGLE_MOBILE = 'views.TOGGLE_MOBILE';
